import React from 'react';

const BS_Pager = () => {
    return (
        <div>
            <h1>BS_Pager Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Pager;
